import { tenantHttp, type HttpClient } from './core/http-client';
import type { BillingOverview, BillingQuote, PaymentOrderStatus } from './models';

export class BillingService {
  constructor(private readonly http: HttpClient) {}

  overview = () => this.http.get<BillingOverview>('/business/billing');

  quote = (planCode: string, months: number) =>
    this.http.post<BillingQuote>('/business/billing/quote', { planCode, months });

  // Returns the payment page (Razorpay / Stripe) to send the browser to.
  createOrder = (planCode: string, months: number) =>
    this.http.post<{ orderId: string; url: string }>('/business/billing/orders', {
      planCode,
      months,
    });

  order = (orderId: string) =>
    this.http.get<PaymentOrderStatus>(`/business/billing/orders/${orderId}`);

  setCountry = (countryCode: string) =>
    this.http.put<{ billingCountry: string }>('/business/billing/country', { countryCode });
}

export const billingService = new BillingService(tenantHttp);
